<script type="text/ecmascript-6">
    import DesignerQuestionSillColour from "../DesignerQuestionSillColour.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionSillColour,
            SynsealQuestion,
        ],
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 0;
            },
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null && key.label !== 'None';
                    });
                } else {
                    return [];
                }
            },
        },
    }
</script>
